import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";

import { BaseElement } from "@/components";

import type { CountdownProps as Props } from "./countdown.types";

@customElement("sb-countdown")
export class SbCountdown extends BaseElement implements Props {
  // ---------------------------
  // PROPS (from backend HTML)
  // ---------------------------

  get _containerElement(): HTMLLIElement | null {
    return this.querySelector(`div[part=${this.id ? this.id : "countdown"}]`);
  }

  @property() content = "";
  @property({ type: Number }) duration = 5;

  @property({ attribute: "redirect-url" }) redirectUrl = "/";

  @property() id = "";

  // ---------------------------
  // STATE
  // ---------------------------
  @state() private seconds = 0;
  private timerId: number | null = null;

  protected createRenderRoot() {
    return this;
  }

  // ---------------------------
  // LIFECYCLE
  // ---------------------------

  connectedCallback() {
    super.connectedCallback();
    this.initializeCountdown();
  }

  disconnectedCallback() {
    this.clearTimer();
    super.disconnectedCallback();
  }

  private initializeCountdown() {
    this.seconds = Math.max(0, this.duration || 0);
    this.startTimer();
  }

  private startTimer() {
    this.clearTimer();

    this.timerId = window.setInterval(() => {
      if (this.seconds <= 1) {
        this.completeCountdown();
      } else {
        this.seconds--;
      }
    }, 1000);
  }

  private completeCountdown() {
    this.clearTimer();
    window.location.href = this.redirectUrl || "/";
  }

  private clearTimer() {
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  private renderContent() {
    return `${this.content} ${this.seconds}s...`;
  }

  // ---------------------------
  // RENDER
  // ---------------------------
  render() {
    return html`
      <div part=${this.id ? this.id : "countdown"}>
        <rtg-typography-p>${this.renderContent()}</rtg-typography-p>
      </div>
    `;
  }
}
